// 优惠券
const ReceiveCoupon = () => import('../pages/coupon/receiveCoupon.vue');
const coupons = () => import('../pages/coupon/coupons.vue');

export default [
  {
    path: '/receiveCoupon',
    component: ReceiveCoupon,
    props: {
      couponId: '123',
    },
  },
  {
    path: '/coupons',
    component: coupons,
    meta: {
      title: '优惠券',
    },
  },
];
